import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FinanceService } from 'src/app/finance/finance.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { tablefields } from '../../../consts/table-requirement-history';

@Component({
    selector: 'app-view-service-catering-history',
    templateUrl: './view-service-catering-history.component.html',
    styleUrls: ['./view-service-catering-history.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ViewServiceCateringHistoryComponent implements OnInit {

	@Input() item: any;
	@Input() type: string; // service - catering
	@Output() closeView = new EventEmitter<any>();

	loading: boolean = false;
	history: any[] = [];
	headers: any[] = [];

	close() {
		this.closeView.emit();
	}

	loadData() {
		// this.loading = true;

		if (this.type == 'service') {
			this._fiS.getServiceHistory(this.item.id).subscribe(
				(data: any) => {
					this.history = data.history;
					this.loading = false;
					this._cD.detectChanges();
				});
			return;
		}

		this._fiS.getCateringHistory(this.item.id).subscribe(
			(data: any) => {
				this.history = data.history;
				this.loading = false;
				this._cD.detectChanges();
			});
	}

	constructor(
		public _fiS: FinanceService,
		public _gS: GlobalService,
		private _cD: ChangeDetectorRef) { }

	ngOnInit() {
		this.headers = JSON.parse(JSON.stringify(tablefields));
		this.loadData();
	}

}
